import { watch, ref, computed } from 'vue'
import { useStore } from 'vuex'
import moment from 'moment'
const KEY = 'UNIQUE_KEY'
let selectedOrders = ref({})
export  function useSelectedOrderFromLocalStorage() {
  const store = useStore()
  const subjects = store.getters['create_protocol/getSubjects']  || init().subjects
  async function init() {
    const subjects = await store.dispatch('create_protocol/loadSubjects', { ass_ativo: 'S' })
    return {
      subjects
    }
  }
  const getEmailUsu = store.getters['session/getUsuEmail'] || ''  
  const STORAGE_KEY = `selected_orders_${getEmailUsu}`
  const storedValue = localStorage.getItem(STORAGE_KEY)
  selectedOrders.value = (storedValue ? JSON.parse(storedValue) : {}) 
   
  const filteredSelectedOrders = computed(() => {
    const filtered = {}
    Object.keys(selectedOrders.value).forEach((key) => {
      const item = selectedOrders.value[key]
      if (Object.keys(item).length > 0 && verifyIfExistRestrinctionSLAForOrder(item)) {
        filtered[key] = item
      } else {
        delete selectedOrders.value[key]
      }
    })
    return filtered 
  })

  watch(filteredSelectedOrders, (newFiltered) => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(newFiltered))    
  }, { deep: true })

  function verifyIfExistRestrinctionSLAForOrder(order) {
    if (!order.dataEntrega) return false

    const reason = subjects.find((item) => item.ASS_ID == order.motivoCodigo)
    if (!reason) return true

    const today = moment()
    const dateOrderFormatada = moment(order.dataEntrega, 'DD/MM/YY')
    const daysDifference = today.diff(dateOrderFormatada, 'days')

    if (reason.ASS_RESTRICAO_SLA === 'S' && daysDifference >= reason.ASS_SLA_TROCA) {
      return false
    } else {
      return true
    }
  }

  const selectOrder = (order) => {
    if (!order.hasOwnProperty(KEY)) return
    const ORDER_KEY = order[KEY] || ''
    selectedOrders.value[ORDER_KEY] = order
  }

  const unselectOrder = (order) => {
    if (!order.hasOwnProperty(KEY)) return
    const ORDER_KEY = order[KEY] || ''
    if (!selectedOrders.value.hasOwnProperty(ORDER_KEY)) return
    delete selectedOrders.value[ORDER_KEY]
  }

  const getSelectedOrders = computed(() => {
    return {...selectedOrders.value}
  }) 

  const clearSelectedOrders = () => {
    selectedOrders.value = {}
  }

  return {
    getSelectedOrders,
    selectOrder,
    unselectOrder,
    clearSelectedOrders
  }
}